//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class CollectionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getBranches(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/collection/branches";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBranches(_response);
        });
    }

    protected processGetBranches(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getTitleByISBN(isbn: string): Promise<ResultResponseOfCollectionItem> {
        let url_ = this.baseUrl + "/api/v1/collection/isbn/{isbn}";
        if (isbn === undefined || isbn === null)
            throw new Error("The parameter 'isbn' must be defined.");
        url_ = url_.replace("{isbn}", encodeURIComponent("" + isbn));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTitleByISBN(_response);
        });
    }

    protected processGetTitleByISBN(response: Response): Promise<ResultResponseOfCollectionItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultResponseOfCollectionItem;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultResponseOfCollectionItem>(null as any);
    }
}

export class ThemakiezerApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getEmbed(embedId: string): Promise<CollectionItem[]> {
        let url_ = this.baseUrl + "/api/v1/collection/themakiezer/{embedId}";
        if (embedId === undefined || embedId === null)
            throw new Error("The parameter 'embedId' must be defined.");
        url_ = url_.replace("{embedId}", encodeURIComponent("" + embedId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetEmbed(_response);
        });
    }

    protected processGetEmbed(response: Response): Promise<CollectionItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CollectionItem[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CollectionItem[]>(null as any);
    }
}

export class WISE_CollectionClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getAvailability(wiseId: number): Promise<ResultResponseOfIEnumerableOfAvailability> {
        let url_ = this.baseUrl + "/api/v1/collection/wise/{wiseId}/availability";
        if (wiseId === undefined || wiseId === null)
            throw new Error("The parameter 'wiseId' must be defined.");
        url_ = url_.replace("{wiseId}", encodeURIComponent("" + wiseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAvailability(_response);
        });
    }

    protected processGetAvailability(response: Response): Promise<ResultResponseOfIEnumerableOfAvailability> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResultResponseOfIEnumerableOfAvailability;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResultResponseOfIEnumerableOfAvailability>(null as any);
    }
}

export class HellodialogClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    inschrijven(token: string | null | undefined, body: Body): Promise<EmptyApiResponse> {
        let url_ = this.baseUrl + "/api/nieuwsbrief/inschrijven";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "X-XSRF-TOKEN": token !== undefined && token !== null ? "" + token : "",
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInschrijven(_response);
        });
    }

    protected processInschrijven(response: Response): Promise<EmptyApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmptyApiResponse;
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmptyApiResponse>(null as any);
    }
}

export interface EmptyApiResponse {
    Status?: Status;
    HttpStatus?: HttpStatusCode;
    HttpStatusCode?: number;
}

export interface ResultResponseOfCollectionItem extends EmptyApiResponse {
    Result?: CollectionItem | undefined;
}

export interface BaseCollectionModel {
    Id: string;
    CandidateIds: string[];
    OriginModule: string;
    OriginalId: string;
    PrefixedId?: string | undefined;
    MoreDataAvailable?: boolean;
    LastUpdate: Date;
}

export interface CollectionItem extends BaseCollectionModel {
    title: string;
    mainTitle?: string | undefined;
    subtitle?: string | undefined;
    series?: string[] | undefined;
    volume?: string | undefined;
    volumeTitle?: string | undefined;
    authors?: string[] | undefined;
    shortDescription?: string | undefined;
    simpleDescription?: string | undefined;
    longDescription?: string | undefined;
    descriptiveTerms?: string[] | undefined;
    genre?: string[] | undefined;
    medium?: Medium;
    isbns?: string[] | undefined;
    fictional?: boolean;
    imageUrls?: { [key: string]: string; } | undefined;
    originalUrl?: string | undefined;
}

export type Medium = "book" | "audiobook" | "comic" | "magazine" | "video" | "videogame" | "game" | "unknown";

export type Status = "Success" | "Error";

export type HttpStatusCode = "Continue" | "SwitchingProtocols" | "Processing" | "EarlyHints" | "OK" | "Created" | "Accepted" | "NonAuthoritativeInformation" | "NoContent" | "ResetContent" | "PartialContent" | "MultiStatus" | "AlreadyReported" | "IMUsed" | "Ambiguous" | "Ambiguous" | "Moved" | "Moved" | "Redirect" | "Redirect" | "RedirectMethod" | "RedirectMethod" | "NotModified" | "UseProxy" | "Unused" | "TemporaryRedirect" | "TemporaryRedirect" | "PermanentRedirect" | "BadRequest" | "Unauthorized" | "PaymentRequired" | "Forbidden" | "NotFound" | "MethodNotAllowed" | "NotAcceptable" | "ProxyAuthenticationRequired" | "RequestTimeout" | "Conflict" | "Gone" | "LengthRequired" | "PreconditionFailed" | "RequestEntityTooLarge" | "RequestUriTooLong" | "UnsupportedMediaType" | "RequestedRangeNotSatisfiable" | "ExpectationFailed" | "MisdirectedRequest" | "UnprocessableEntity" | "Locked" | "FailedDependency" | "UpgradeRequired" | "PreconditionRequired" | "TooManyRequests" | "RequestHeaderFieldsTooLarge" | "UnavailableForLegalReasons" | "InternalServerError" | "NotImplemented" | "BadGateway" | "ServiceUnavailable" | "GatewayTimeout" | "HttpVersionNotSupported" | "VariantAlsoNegotiates" | "InsufficientStorage" | "LoopDetected" | "NotExtended" | "NetworkAuthenticationRequired";

export interface ResultResponseOfIEnumerableOfAvailability extends EmptyApiResponse {
    Result?: Availability[] | undefined;
}

export interface Availability {
    BranchId?: string | undefined;
    BranchName?: string | undefined;
    Location?: string | undefined;
    CallNumber?: string | undefined;
    EffectiveStatus?: string | undefined;
    EffectiveStatusCode?: string | undefined;
}

export interface ErrorResponse extends EmptyApiResponse {
    Status?: Status;
    Message?: string | undefined;
}

export interface Body {
    email?: string;
    voornaam?: string;
    achternaam?: string;
    geslacht?: BodyGeslacht;
    groups?: number[];
    _state?: Body_state;
    _language?: Body_language;

    [key: string]: any;
}

export type BodyGeslacht = "M" | "F";

export type Body_state = "Optin" | "Unsubscriber" | "Bounced" | "Contact";

export type Body_language = "NL" | "EN" | "DE" | "SE";

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}